import { BaseProtoDto } from '../../../shared/modules/base/dtos/base-proto.dto';
import { ProtoAreaDto } from '../../areas/dtos/proto-area.dto';

/**
 * Proto Country DTO
 */
export class ProtoCountryDto extends BaseProtoDto {
	/**
	 * Country name
	 */
	name!: string;

	/**
	 * ISO 3166-1 alpha-2 country code
	 */
	isoCode!: string;

	/**
	 * Flag indicating whether this country is in use
	 */
	isVisible!: boolean;

	/**
	 * Flag indicating whether this country is a market where business is conducted
	 */
	isMarket!: boolean;

	/**
	 * Areas within the country
	 */
	areas?: ProtoAreaDto[];
}
